/**
 * MobileConsentModal — v1.12.992
 *
 * Consentement analytics OPT-IN au 1er lancement (mobile). RGPD/ePrivacy : GA4
 * n'est pas exempté de consentement (données vers Google/US) → on demande
 * AVANT toute collecte. Le choix est persisté (AsyncStorage 'outfit_cookie_consent')
 * et modifiable ensuite via Profil › Confidentialité.
 *
 * Rendu potentiellement HORS I18nProvider (root App.js) → on utilise getCurrentLang(),
 * pas useI18n().
 */
import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Linking } from 'react-native';
import AppModal from './AppModal';

export default function MobileConsentModal({ visible, onAccept, onDecline }) {
  if (!visible) return null;
  let en = false;
  try { en = require('../i18n').getCurrentLang() === 'en'; } catch (_) {}

  return (
    <AppModal visible transparent animationType="fade">
      <View style={s.overlay}>
        <View style={s.card}>
          <Text style={s.title}>{en ? '🍪 Privacy' : '🍪 Confidentialité'}</Text>
          <Text style={s.body}>
            {en
              ? 'With your permission, we use audience measurement (Google Analytics) to improve your experience. No advertising, no data sale. You can change this anytime in Profile › Privacy.'
              : "Avec votre permission, nous utilisons un outil de mesure d'audience (Google Analytics) pour améliorer votre expérience. Aucune publicité, aucune revente de données. Modifiable à tout moment dans Profil › Confidentialité."}
          </Text>
          <Text
            style={s.link}
            onPress={() => { try { Linking.openURL('https://www.mytenue.com/privacy'); } catch (_) {} }}
          >
            {en ? 'Learn more' : 'En savoir plus'}
          </Text>
          <TouchableOpacity style={s.accept} onPress={onAccept} activeOpacity={0.85}>
            <Text style={s.acceptTxt}>{en ? 'Accept' : 'Accepter'}</Text>
          </TouchableOpacity>
          <TouchableOpacity style={s.decline} onPress={onDecline} activeOpacity={0.7}>
            <Text style={s.declineTxt}>{en ? 'Decline' : 'Refuser'}</Text>
          </TouchableOpacity>
        </View>
      </View>
    </AppModal>
  );
}

const s = StyleSheet.create({
  overlay: { flex: 1, backgroundColor: 'rgba(0,0,0,0.55)', justifyContent: 'flex-end' },
  card: {
    backgroundColor: '#FFFFFF', borderTopLeftRadius: 24, borderTopRightRadius: 24,
    paddingHorizontal: 24, paddingTop: 24, paddingBottom: 34,
  },
  title: { fontSize: 18, fontWeight: '700', color: '#1A1A1A', marginBottom: 10 },
  body: { fontSize: 13, lineHeight: 19, color: '#555', marginBottom: 10 },
  link: { fontSize: 13, color: '#9B7B5A', textDecorationLine: 'underline', marginBottom: 18 },
  accept: { backgroundColor: '#1A1A1A', paddingVertical: 14, borderRadius: 100, alignItems: 'center' },
  acceptTxt: { color: '#FFFFFF', fontSize: 14, fontWeight: '700', letterSpacing: 0.5 },
  decline: { paddingVertical: 13, alignItems: 'center', marginTop: 4 },
  declineTxt: { color: '#888', fontSize: 13, fontWeight: '600' },
});
